
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiDiodes05Off as ObiDiodes05OffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-diodes-05-off.js';
 
 
 

 
 export const ObiDiodes05Off = createComponent({
   react: React,
   tagName: 'obi-diodes-05-off',
   elementClass: ObiDiodes05OffElement,
   events: {
     
   }
  });
 
 